import at from 'lodash/at';
import React, { ChangeEvent } from 'react';

import { ValueBox, ValueGroup, ValueInput } from '@candu-ai/craft/ui';
import { NavigateAction } from 'craft/types';
import { clearLinkField } from 'craft/utils/parseLink';

import { InteractionFieldProps } from './interactionFields';

export const MailToField = ({
  defaultValue,
  onChange,
}: InteractionFieldProps<NavigateAction['handler']>) => {
  const onChangeHref = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    return onChange({
      ...defaultValue,
      href: `mailto:${value}`,
    });
  };

  return (
    <ValueGroup>
      <ValueBox
        isInGroup={{
          isLast: true,
        }}
        label="To"
      >
        <ValueInput
          placeholder="hello@example.com"
          value={clearLinkField(at(defaultValue as any, 'href')[0])}
          onChange={onChangeHref}
        />
      </ValueBox>
    </ValueGroup>
  );
};
